import { toast as sonnerToast } from "sonner"
import type { ReactNode } from "react"

type ToastOptions = {
  title?: ReactNode
  description?: ReactNode
  variant?: "default" | "destructive"
  duration?: number
  action?: { label: ReactNode; onClick: () => void } | ReactNode
}

function normalizeAction(action: ToastOptions["action"]) {
  if (!action) return undefined
  if (
    typeof action === "object" &&
    action !== null &&
    "label" in (action as Record<string, unknown>) &&
    "onClick" in (action as Record<string, unknown>)
  ) {
    return action as { label: ReactNode; onClick: () => void }
  }
  return undefined
}

function toast({ title, description, variant, duration, action }: ToastOptions) {
  const opts = {
    description,
    duration,
    action: normalizeAction(action),
  }
  if (variant === "destructive") {
    return sonnerToast.error((title as string) ?? "Error", opts)
  }
  return sonnerToast((title as string) ?? "", opts)
}

function useToast() {
  return {
    toast,
    toasts: [] as never[],
    dismiss: (id?: string | number) => sonnerToast.dismiss(id),
  }
}

export { useToast, toast }
